// src/api/config.js - COMPLETE FIXED VERSION
import axios from 'axios';

// Create axios instance with token authentication
const api = axios.create({
  baseURL: '/api',
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  },
});

// Helper to get CSRF token from cookies
function getCookie(name) {
  let cookieValue = null;
  if (document.cookie && document.cookie !== '') {
    const cookies = document.cookie.split(';');
    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i].trim();
      if (cookie.substring(0, name.length + 1) === (name + '=')) {
        cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
        break;
      }
    }
  }
  return cookieValue;
}

// Request interceptor - UPDATED FOR TOKEN AUTH
api.interceptors.request.use(
  (config) => {
    // Get token from localStorage (like payment system)
    const token = localStorage.getItem('authToken') || 
                  localStorage.getItem('access_token') ||
                  sessionStorage.getItem('authToken');
    
    // Add Authorization header if token exists
    if (token) {
      config.headers['Authorization'] = `Token ${token}`;
      console.log(`🔐 Adding token to request: ${token.substring(0, 20)}...`);
    } else {
      console.log('⚠️ No auth token found');
    }
    
    // Add CSRF token for non-GET requests (for session auth fallback)
    if (['post', 'put', 'patch', 'delete'].includes(config.method.toLowerCase())) {
      const csrfToken = getCookie('csrftoken');
      if (csrfToken) {
        config.headers['X-CSRFToken'] = csrfToken;
      }
    }
    
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor
api.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error('API Error:', {
      status: error.response?.status,
      data: error.response?.data,
      url: error.config?.url,
      method: error.config?.method
    });
    
    if (error.response?.status === 401) {
      console.log('🔐 401 Unauthorized - Redirecting to login');
      // Clear auth data
      localStorage.removeItem('authToken');
      localStorage.removeItem('access_token');
      localStorage.removeItem('user');
      sessionStorage.removeItem('authToken');
      
      // Redirect to login if not already there
      if (!window.location.pathname.includes('/login')) {
        window.location.href = '/login?session=expired';
      }
    } else if (error.response?.status === 403) {
      console.error('🔒 403 Forbidden:', error.response?.data);
    }
    
    return Promise.reject(error);
  }
);

export default api;